import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-looker-list-item',
  templateUrl: './looker-list-item.component.html',
  styleUrls: ['./looker-list-item.component.scss']
})
export class LookerListItemComponent {


  @Input()
  meta: any;

  constructor(
    private router: Router,
    private location: Location
  ) {
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/manage', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }


  setActiveNav(navLink): boolean {
    const currentPath = this.location.path();
    return navLink === currentPath;
  }

}
